/* eslint-disable */
import React from 'react';
import { withRouter } from 'react-router';
import { observer } from 'mobx-react';
import { StyleSheet, css } from 'aphrodite/no-important';

import '../assets/styles/class.scss';
import QuestionsVM from '../viewModels/QuestionsVM';
import HeaderSkipGreen from '../components/HeaderSkipGreen';
import Answers from '../components/Answers.jsx';
import Indexes from '../components/Indexes';

@observer
class QuestionsView extends React.Component {
  vm = new QuestionsVM();

  handlerSkip = () => {
    this.vm.selectAnswer(0);
    this.vm.nextQuestion();
  };

  // 選擇 0 分的答案.
  handlerNext = () => {
    const answerIndex = 0;
    this.vm.selectAnswer(answerIndex);
    this.vm.videoPlay();
  };

  // 選擇 1 分的答案.
  handlerIncrease = () => {
    const answerIndex = 1;
    this.vm.selectAnswer(answerIndex);
    this.vm.videoPlay();
  };

  componentDidMount() {
    this.vm.init({ history: this.props.history });

    this.props.getMuted();
  }

  render() {
    const { vm } = this;
    const { isMuted, setMuted } = this.props;

    if (vm.questions.length === 0) {
      return '';
    }

    if (vm.isPlay) {
      return (
        <Answers
          questions={vm.questions}
          answers={vm.answers}
          index={vm.index}
          videoEnd={vm.videoEnd}
          isMuted={isMuted}
          setMuted={setMuted}
        />
      );
    }

    return (
      <div
        style={{
          '--src': `url(${require('assets/Slice.png').default})`
        }}
        className={`questions position ${css(
          styles.group,
          styles.group_layout
        )}`}
      >
        <div className={css(styles.flex, styles.flex_layout1)}>
          <div className={css(styles.group1, styles.group1_layout)}>
            <div className={css(styles.component, styles.component_layout)}>
              <HeaderSkipGreen isMuted={isMuted} setMuted={setMuted} />
            </div>
          </div>

          <div className={css(styles.flex_spacer)} />
          <h3 className={css(styles.subtitle, styles.subtitle_layout)}>
            {vm.findQuestionData.question}
          </h3>
          <div className={css(styles.flex_spacer1)} />

          <div className={css(styles.flex1, styles.flex1_layout)}>
            <div className={css(styles.flex_item)}>
              <div
                className={`${css(
                  styles.group2,
                  styles.group2_layout
                )} cursor-pointer button`}
                onClick={this.handlerNext}
              >
                <h3 className={css(styles.subtitle1, styles.subtitle1_layout)}>
                  {vm.findQuestionData.answers[0].content}
                </h3>
              </div>
            </div>
            <div className={css(styles.flex_spacer2)} />
            <div className={css(styles.flex_item)}>
              <div
                className={`${css(
                  styles.group3,
                  styles.group3_layout
                )} cursor-pointer button`}
                onClick={this.handlerIncrease}
              >
                <h3 className={css(styles.subtitle2, styles.subtitle2_layout)}>
                  {vm.findQuestionData.answers[1].content}
                </h3>
              </div>
            </div>
          </div>

          <div className={css(styles.flex_spacer3)} />

          <div className={css(styles.flex, styles.flex_layout)}>
            {vm.index !== 0 && (
              <h5
                className={`${css(
                  styles.txt,
                  styles.txt_layout
                )} cursor-pointer`}
                onClick={vm.prevQuestion}
              >
                {'上一題'}
              </h5>
            )}

            <div className={css(styles.group4, styles.group4_layout)}>
              <div className={css(styles.component, styles.component_layout1)}>
                <Indexes index={vm.index} questions={vm.questions} />
              </div>
            </div>
          </div>

          <img
            src={require('assets/1ec6cb0dcc3e019fd8e9ae71f69fc7d1.png').default}
            className={css(styles.cover_group, styles.cover_group_layout)}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(QuestionsView);

QuestionsView.inStorybook = true;

const styles = StyleSheet.create({
  group: {
    display: 'flex',
    background: 'var(--src) center center / cover no-repeat',
    backgroundColor: 'rgb(255,255,255)',
    borderRadius: '0px 0px 0px 0px'
  },
  group_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: 0
  },
  flex: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex_layout1: {
    position: 'relative',
    flexGrow: 1,
    margin: '50px 0px',
    '@media (max-width: 575.98px)': {
      margin: '24px 0px'
    }
  },
  group1: {
    display: 'flex'
  },
  group1_layout: {
    position: 'relative',
    flex: '0 0 auto',
    height: 39,
    margin: '0px 165px',
    '@media (max-width: 1199.98px)': {
      margin: '2px 83px 0px'
    },
    '@media (max-width: 991.98px)': {
      margin: '1px 42px 0px'
    },
    '@media (max-width: 767.98px)': {
      margin: '1px 21px 0px'
    },
    '@media (max-width: 575.98px)': {
      margin: '1px 11px 0px'
    }
  },
  component: {},
  component_layout: {
    flexGrow: 1,
    margin: '0px 3px 0px 0px'
  },
  flex_spacer: {
    flex: '1 1 214px'
  },
  subtitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '500 20px/1.7 "NotoSansCJKtc", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  subtitle_layout: {
    flex: '0 0 auto',
    width: 1440,
    minWidth: 1440,
    margin: '0px auto',
    '@media (max-width: 1399.98px)': {
      width: 700,
      minWidth: 700
    },
    '@media (max-width: 767.98px)': {
      width: 420,
      minWidth: 420
    },
    '@media (max-width: 575.98px)': {
      width: 340,
      minWidth: 340
    }
  },
  flex_spacer1: {
    flex: '1 1 80px'
  },
  flex1: {
    display: 'flex',
    '@media (max-width: 767.98px)': {
      flexWrap: 'wrap',
      rowGap: 20
    }
  },
  flex1_layout: {
    position: 'relative',
    flex: '0 0 auto',
    height: 'min-content',
    width: 580,
    minWidth: 580,
    margin: '0px auto',
    '@media (max-width: 1199.98px)': {
      margin: '25px auto 0px'
    },
    '@media (max-width: 991.98px)': {
      margin: '13px auto 0px'
    },
    '@media (max-width: 767.98px)': {
      width: 405,
      minWidth: 405,
      margin: '28px auto 0px'
    },
    '@media (max-width: 575.98px)': {
      width: 336,
      minWidth: 336,
      margin: '12px auto 0px'
    }
  },
  flex_item: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 255px',
    '@media (max-width: 767.98px)': {
      flex: '0 0 100%'
    }
  },
  group2: {
    display: 'flex',
    border: '1px solid rgb(17,17,17)',
    borderRadius: '8px 8px 8px 8px'
  },
  group2_layout: {
    position: 'relative',
    flexGrow: 1,
    '@media (max-width: 575.98px)': {
      minHeight: 64,
      margin: 0
    }
  },
  subtitle1: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '20px/1.7 "PingFangSC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    textAlign: 'center',
    letterSpacing: '0px',
    '@media (max-width: 575.98px)': {
      fontSize: '16px',
      textAlign: 'center'
    }
  },
  subtitle1_layout: {
    flexGrow: 1,
    margin: 16
  },
  flex_spacer2: {
    flex: '0 0 auto',
    minWidth: 30,
    '@media (max-width: 767.98px)': {
      display: 'none'
    }
  },
  group3: {
    display: 'flex',
    border: '1px solid rgb(17,17,17)',
    borderRadius: '8px 8px 8px 8px'
  },
  group3_layout: {
    position: 'relative',
    flexGrow: 1,
    '@media (max-width: 575.98px)': {
      minHeight: 64,
      margin: 0
    }
  },
  subtitle2: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '20px/1.7 "PingFangSC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    textAlign: 'center',
    letterSpacing: '0px',
    '@media (max-width: 575.98px)': {
      fontSize: '16px',
      textAlign: 'center'
    }
  },
  subtitle2_layout: {
    flexGrow: 1,
    margin: 16
  },
  flex_spacer3: {
    flex: '1 1 164px'
  },
  flex_layout: {
    position: 'relative',
    flex: '0 0 auto',
    width: 490,
    minWidth: 490,
    margin: '0px auto',
    '@media (max-width: 575.98px)': {
      width: 360,
      minWidth: 360
    }
  },
  flex_item1: {
    display: 'flex',
    position: 'relative'
  },
  txt: {
    display: 'flex',
    justifyContent: 'flex-end',
    font: '500 16px/1.75 "NotoSansCJKtc", Helvetica, Arial, serif',
    color: 'rgb(197,75,56)',
    textAlign: 'right',
    letterSpacing: '0px'
  },
  txt_layout: {
    width: 'fit-content',
    margin: '0px auto'
  },
  group4: {
    display: 'flex'
  },
  group4_layout: {
    position: 'relative',
    margin: '18px 0px 0px',
    '@media (max-width: 383.98px)': {
      margin: '10px 0px 0px'
    }
  },
  component_layout1: {
    flexGrow: 1,
    '@media (max-width: 575.98px)': {
      margin: '9px 0px 0px'
    }
  },
  cover_group: {
    width: '100%',
    height: 'auto'
  },
  cover_group_layout: {
    flex: '0 0 auto',
    margin: '0px 0px 58.5px',
    '@media (max-width: 99999px)': {
      margin: '100px 0px 58.5px',
      display: 'flex'
    },
    '@media (max-width: 2999.98px)': {
      margin: '80px 0px 58.5px'
    },
    '@media (max-width: 1919.98px)': {
      margin: '40px 0px 58.5px'
    },
    '@media (max-width: 1399.98px)': {
      margin: '40px 0px 60px'
    },
    '@media (max-width: 1199.98px)': {
      margin: '20px 0px'
    },
    '@media (max-width: 991.98px)': {
      margin: '60px 0px 25px'
    },
    '@media (max-width: 575.98px)': {
      margin: '60px 0px'
    }
  }
});
